import {
    Grid,
    Accordion,
    AccordionSummary,
    AccordionDetails,
} from '@material-ui/core';
import {P} from 'components/TypographyShortcuts';
import {PBold} from 'components/TypographyShortcuts';
import {ExpandMore} from '@material-ui/icons';
import useWindowSize from 'hooks/useWindowSize';
import VesselCard from './VesselCard';
import useIsCg719s from '../hooks/useIsCg719s';

const MyVessels = ({recommended, selectedId, handleDetailVesselUpdate}) => {
    const isCg719s = useIsCg719s();
    const {width} = useWindowSize();

    if (recommended?.length) {
        return (
            <Accordion defaultExpanded={!selectedId}>
                <AccordionSummary
                    expandIcon={<ExpandMore />}
                    aria-controls='my-vessels-content'
                    id='my-vessels-header'
                >
                    <PBold align='center'>My Vessels</PBold>
                </AccordionSummary>
                <AccordionDetails
                    style={{
                        padding: width < 400 ? '8px 2px 16px 0px' : null,
                    }}
                >
                    <Grid
                        container
                        spacing={1}
                        style={{
                            maxHeight: '500px',
                            overflowY: 'scroll',
                        }}
                    >
                        {recommended?.map(vessel => (
                            <Grid item xs={12} key={vessel?.id}>
                                <VesselCard
                                    vessel={vessel}
                                    selectedId={selectedId}
                                    handleDetailVesselUpdate={
                                        handleDetailVesselUpdate
                                    }
                                    isCg719s={isCg719s}
                                />
                            </Grid>
                        ))}
                    </Grid>
                </AccordionDetails>
            </Accordion>
        );
    } else if (!selectedId) {
        return (
            <P>
                You haven't entered sea time on any boats before. Try using our
                Vessel Search to get started. If you don't find your boat with
                our tool you can click "I don't see my boat" to manually enter
                the vessel information.
            </P>
        );
    } else {
        return null;
    }
};

export default MyVessels;
